import { render, staticRenderFns } from "./ShiftTable.vue?vue&type=template&id=26528856&"
import script from "./ShiftTable.vue?vue&type=script&lang=js&"
export * from "./ShiftTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports